import { Box, Paper, useTheme } from '@mui/material';
import React from 'react';
/**
 * @deprecated created to help with old component migration.
 */
export const AppPaper = (props) => {
    const theme = useTheme();
    const sx = {
        width: props.contentWidth ? getContentWidth(props.contentWidth) : undefined,
        padding: props.contentPadding ? theme.spacing(props.contentPadding) : 0,
        margin: props.contentWidth ? 'auto' : undefined,
        borderRadius: {
            xs: 0,
            md: theme.shape.borderRadius,
        },
        boxShadow: {
            xs: 0,
            md: 4,
        },
    };
    return (React.createElement(Box, { sx: {
            m: {
                md: 2,
            },
        } },
        React.createElement(Paper, { sx: sx, elevation: 4 }, props.children)));
};
function getContentWidth(contentWidth) {
    return typeof contentWidth === 'string' ? `min(100vw, ${contentWidth})` : `min(100vw, ${contentWidth}px)`;
}
